define('ItemAvailability.View', [
    'Backbone',
    'jQuery',
    'underscore',
    '_itemavailability.tpl',
    'SC.Configuration'
], function ItemAvailabilityViewFn(
    Backbone,
    jQuery,
    _,
    ItemAvailabilityViewTpl,
    Configuration
) {
    'use strict';

    return Backbone.View.extend({

        template: ItemAvailabilityViewTpl,

        initialize: function initialize(options) {
            this.application = options.application;
            this.model = options.model;
        },

        getContext: function getContext() {
            var showNotStockMessage = this.model.get('item').get('_stock') === 0;
            var showOverOrderStock = this.model.get('item').get('_stock') !== 0 && this.model.get('quantity') > this.model.get('item').get('_stock');
            var showOutOfStockMessage = this.model.get('item') && this.model.get('item').get('showoutofstockmessage');
            var isBackordable = this.model.get('item') && this.model.get('item').get('isbackorderable');
            var isDispalyOutOfStock = this.model.get('item') && this.model.get('item').get('outofstockbehavior') === 'Allow back orders but display out-of-stock message';
            var hasMessage = showNotStockMessage || showOverOrderStock;
            var showWarningMessage = (hasMessage && (showOutOfStockMessage || !isBackordable)) || (showOverOrderStock && isDispalyOutOfStock);
            return {
                showWarningMessage: showWarningMessage,
                showNotStockMessage: showNotStockMessage,
                showOverOrderStock: showOverOrderStock,
                quantityAvailability: this.model.get('item').get('_stock'),
                noStockMessage: Configuration.get('itemAvailability.noStockAvailableMessage'),
                onlyXAvailableMessage: Configuration.get('itemAvailability.onlyAvailableMessage', '')
                    .replace('[0]', this.model.get('item').get('_stock'))
            };
        }
    });
});
